"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typeChecker_1 = require("./typeChecker");
exports.getMaskedNaverId = function (naverId) {
    if (naverId && typeChecker_1.default.isString(naverId)) {
        var maskedNaverId = void 0;
        switch (naverId.length) {
            case 1:
                maskedNaverId = '*';
            case 2:
                maskedNaverId = naverId.substring(0, 1) + '*';
            case 3:
                maskedNaverId = naverId.substring(0, 2) + '**';
            case 4:
                maskedNaverId = naverId.substring(0, 3) + '***';
            default:
                maskedNaverId = naverId.substring(0, 4) + '****';
        }
        return maskedNaverId;
    }
    return naverId;
};
//# sourceMappingURL=naverProfile.js.map